exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "task-monitor {\n  display: block;\n}\n.not-started {\n  color: var(--color-concrete);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/task/monitor/taskMonitor.directive.less
// module id = 2473
// module chunks = 0